import { render } from "./SignalItemNew.vue?vue&type=template&id=35578a42"
import script from "./SignalItemNew.vue?vue&type=script&lang=js"
export * from "./SignalItemNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__